import React from '../helpers/react';
import {getHookClass} from '../helpers/cssHooks.js';

import classList from 'ereader-core/dist/classList';
import CommentModerationBox from './CommentModerationBox.js';

export const CommentBox = React.createClass({
    getInitialState: function() {
        return {};
    },
    toggleComments: function(){
        this.props.toggleComments(this.props.id);
    },
    setComment: function(e){
        this.setState({
            commentValue: e.target.value
        });
    },
    renderComment: function(commentData, index) {
        let userpic = commentData.userImageLink || 'https://c.cheggcdn.com/chegg-solution-player/prod/1.6.10/images/profile.gif';
        let commentClass = classList('comment');
        if (commentData.is_posting || commentData.is_deleting) {
            commentClass.push('posting');
        }
        // Need to split the comment by lines.
        let comment_lines = commentData.comment.replace(/[\n\r]/,'\n ').split(/\n/);
        let comment_text = comment_lines.map((comment_line, index)=>{
            return <p key={index}>{comment_line.trim()}</p>
        });

        let is_moderator = this.props.user.isModerator;
        let moderator_box = is_moderator ? <CommentModerationBox
            commentData={commentData}data-id
            getDef={this.props.getDef}
            solutionId={this.props.solution_id}
            problemId={this.props.problemId}
            removeComment={this.props.removeComment}/> : '';
      const commentAriaLabel = 'comment pic step ' + (this.props.step + 1) + ' comment no ' + (index + 1);

      return (
            <li className={commentClass} key={index}>
                <header className="comment-header">
                    <img className="comment-pic" src={userpic} alt={commentAriaLabel}/>
                    <span className="comment-name">{commentData.userNickname}</span>
                </header>
                <article className="comment-text">{comment_text}</article>
                {moderator_box}
            </li>
        );
    },
    postComment: function(){
        if(typeof this.refs.textbox.value === "string" && this.refs.textbox.value.trim() === '') {
            return;
        }
        this.props.postComment({
            solution_id: this.props.solution_id,
            comment: this.state.commentValue,
            userNickname: this.props.user.nickname,
            stepIndex: this.props.step,
            problemId: this.props.problemId
        });
        this.refs.textbox.value = '';
          this.setState({
            commentValue: ''
          });
    },
    keyDownComment: function(e){
        // # Accessibility -- let element respond to ENTER and SPACE
        if(e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            e.currentTarget.click();
            return false;
        }
        // # Accessibility -- let element respond to Shift + Tab
        if(e.shiftKey && e.keyCode === 9) {
            e.preventDefault();
            if (document.getElementById('problem-previous').getAttribute('aria-label') != "") {
                document.getElementById('problem-previous').focus();
            }
            else if(!this.props.show_fullscreen) {
                 document.getElementById('show-all-steps').focus();
            }
            else {
                document.getElementById('fullscreen').focus();
            }
        }
    },
    render: function() {
        let comments = this.props.comments.filter((comment)=>{
            return comment.stepIndex == this.props.step;
        });
        let comments_list = comments.map(this.renderComment);

        const textAriaLabel = 'comment text box step ' + (this.props.step + 1);
        const commentAriaLabel = 'my pic step ' + (this.props.step + 1);
        let postbox = (
            <div className="post-comment" key="post">
                <img className="comment-pic" src="https://c.cheggcdn.com/chegg-solution-player/prod/1.6.10/images/profile.gif" alt={commentAriaLabel} />
                <div className="comment-text-wrapper">
                    <textarea ref="textbox" onChange={this.setComment} aria-label={textAriaLabel} ></textarea>
                    <button className="submit-button" onClick={this.postComment}>{this.props.getDef('comments.submit')}</button>
                </div>
            </div>
        );
        let content = !this.props.opened ? '' :  [<ul key="comments">{comments_list}</ul>, postbox];
        let className = classList('comment-box', getHookClass('CommentBox'));

        return <section className={className}>
            <a onKeyDown={(e)=>this.keyDownComment(e)} className="solution-comments comments-toggle" onClick={this.toggleComments} aria-expanded={this.props.opened || false} href="javascript:;">{this.props.getDef('comments.comments-count',comments.length)}</a>
            {content}
        </section>;
    }
});

export default CommentBox;


// WEBPACK FOOTER //
// ./src/components/CommentBox.js